/* Onglets de fiche spa — deplace les sections existantes dans des panneaux.
   Voir l'en-tete de `sections/p-spa-onglets.liquid` pour le pourquoi.

   Quatre garde-fous qui ont chacun coute une mesure :
   ① les chapitres de la description sont ranges par ROLE, jamais par numero : sur
      37 fiches, seules 23 ont la charpente a trois titres ;
   ② le chapitre « showroom » n'est reconnu que s'il est le dernier — sinon
      « L'univers SOMMUM SPAS » partait en fin de fiche ;
   ③ un onglet dont rien n'a ete trouve est retire (bain-froid n'a pas de section
      gamme, endless n'a pas de manuel) — un onglet vide se lit comme une panne ;
   ④ on se rebranche sur `shopify:section:load` : dans l'editeur, Shopify reinjecte
      une section a sa place d'origine et elle ressortirait de son onglet. */
(function () {
  'use strict';

  /* Comparaison tolerante : sans accent, sans casse. « CARACTÉRISTIQUES » et
     « Caracteristiques techniques » doivent tomber sur le meme motif. */
  function pliable(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase();
  }

  function init(racine) {
    if (racine.dataset.spaOngPret === '1') return;

    var panneaux = Array.prototype.slice.call(racine.querySelectorAll('.spa-ong__panneau'));
    var tabs = Array.prototype.slice.call(racine.querySelectorAll('.spa-ong__tab'));
    if (!panneaux.length) return;

    var moi = racine.closest('.shopify-section');
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
    function parCle(cle) {
      cle = String(cle).trim();
      if (!cle) return null;
      var fin = '__' + cle;
      for (var i = 0; i < sections.length; i++) {
        var s = sections[i];
        if (s !== moi && s.id && s.id.slice(-fin.length) === fin) return s;
      }
      return null;
    }

    /* --- la description, coupee a ses h2 puis classee par role ------------- */
    var chapitres = [];
    var secDesc = parCle(racine.dataset.cleDesc || '');
    if (secDesc) {
      var h2 = secDesc.querySelector('h2');
      var hote = h2 ? h2.parentElement : null;
      if (hote) {
        var courant = { titre: '', els: [] };
        Array.prototype.slice.call(hote.children).forEach(function (el) {
          if (el.tagName === 'H2') {
            chapitres.push(courant);
            courant = { titre: el.textContent, els: [el] };
          } else {
            courant.els.push(el);
          }
        });
        chapitres.push(courant);
      } else {
        chapitres.push({ titre: '', els: Array.prototype.slice.call(secDesc.children) });
      }
    }

    function motif(nom, defaut) {
      var v = (racine.dataset[nom] || defaut || '').trim();
      return v ? new RegExp(pliable(v)) : null;
    }
    var reSpecs = motif('motifSpecs', 'caracteristiques|dimensions');
    var reShow = motif('motifShowroom', 'decouvrez|showroom');

    var role = chapitres.map(function () { return 'presentation'; });
    chapitres.forEach(function (c, i) {
      if (c.titre && reSpecs && reSpecs.test(pliable(c.titre))) role[i] = 'specs';
    });
    /* ② seul le DERNIER chapitre peut etre le renvoi showroom. */
    var d = chapitres.length - 1;
    if (d > 0 && chapitres[d].titre && reShow && reShow.test(pliable(chapitres[d].titre))) {
      role[d] = 'showroom';
    }

    /* --- remplissage des panneaux ----------------------------------------- */
    panneaux.forEach(function (p, i) {
      var recu = 0;
      var voulu = p.dataset.role || 'aucun';

      if (voulu !== 'aucun') {
        chapitres.forEach(function (c, n) {
          if (role[n] !== voulu || !c.els.length) return;
          var env = document.createElement('div');
          env.className = 'spa-ong__chapitre';
          c.els.forEach(function (el) { env.appendChild(el); });
          if (env.childNodes.length) { p.appendChild(env); recu++; }
        });
      }

      (p.dataset.cles || '').split(',').forEach(function (cle) {
        var s = parCle(cle);
        if (!s) return;
        p.appendChild(s);
        s.classList.add('spa-ong__section');
        recu++;
      });

      if (!recu) {
        /* ③ rien a montrer : on retire l'onglet ET son panneau. */
        p.remove();
        if (tabs[i]) tabs[i].remove();
      }
    });

    tabs = Array.prototype.slice.call(racine.querySelectorAll('.spa-ong__tab'));
    panneaux = Array.prototype.slice.call(racine.querySelectorAll('.spa-ong__panneau'));
    if (!tabs.length || !panneaux.length) return;

    /* La section de description est vide desormais : sans ca elle laisserait une
       bande de padding au milieu de la page (36 px mesures le 17/09).
       🛑 On teste `innerText`, pas `textContent` : Shopify pose un `<style>` de
       padding DANS la section, et son contenu compte dans `textContent` — la
       section paraissait donc pleine alors qu'elle ne montrait plus rien. */
    if (secDesc && !(secDesc.innerText || '').trim()) secDesc.hidden = true;

    function montre(n) {
      tabs.forEach(function (t, j) {
        var actif = j === n;
        t.setAttribute('aria-selected', actif ? 'true' : 'false');
        t.tabIndex = actif ? 0 : -1;
        panneaux[j].hidden = !actif;
      });
    }
    montre(0);

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { montre(i); });
      t.addEventListener('keydown', function (e) {
        var d2 = 0;
        if (e.key === 'ArrowRight') d2 = 1;
        else if (e.key === 'ArrowLeft') d2 = -1;
        else if (e.key === 'Home') d2 = -i;
        else if (e.key === 'End') d2 = tabs.length - 1 - i;
        else return;
        e.preventDefault();
        var n = (i + d2 + tabs.length) % tabs.length;
        tabs[n].focus();
        montre(n);
      });
    });

    /* Un lien d'ancre qui vise un contenu range dans un onglet ferme ne menerait
       nulle part : on ouvre l'onglet qui le contient avant de sauter. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href') === '#') return;
      var cible = document.getElementById(a.getAttribute('href').slice(1));
      if (!cible) return;
      panneaux.forEach(function (p, j) {
        if (p.contains(cible) && p.hidden) montre(j);
      });
    });

    racine.hidden = false;
    racine.dataset.spaOngPret = '1';
  }

  function lance() {
    document.querySelectorAll('[data-spa-onglets]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lance);
  } else {
    lance();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-spa-onglets]').forEach(function (r) {
      delete r.dataset.spaOngPret;
      init(r);
    });
  });
})();
